import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted, ref, watch } from 'vue';
  import { loadScript } from 'vue-plugin-load-script';
  import { GOOGLE_MAP_API_URL } from '@/constants';
  import _ from 'lodash';
  import { getLocationIcon } from '../utils';

  export type Location = {
    id: number;
    title: string;
    address: string;
    phoneNumber: string;
    lat?: number;
    lng?: number;
    postal_code?: string;
    opening_hours?: string;
    pdo?: boolean; // pdo类型地址
    show_phone_on_map?: boolean;
  }

  export interface IProps {
    list: Location[];
    centerLocation?: Location
  }type LocationMap = {
    [propName: string]: google.maps.LatLng
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    list: null,
    centerLocation: null
  },
  setup(__props: any) {

const props = __props as {
    list: Location[];
    centerLocation?: Location
  }

  ;

  
  const root = ref();
  const isJapan = process.env.VUE_APP_COUNTRY === 'ja';
  let map: google.maps.Map;
  const locationMap: LocationMap = {};
  const markerMap: {[key: string]: { infoWindow: google.maps.InfoWindow, marker: google.maps.Marker }} = {};

  const loadMap = async () => {
    await loadScript(GOOGLE_MAP_API_URL);
    return new google.maps.Map(root.value, {
      zoom: 12,
    });
  };

  async function setMarker(location: google.maps.LatLng, address: Location) {
    return new google.maps.Marker({
      position: location,
      icon: getLocationIcon(address.pdo),
      map
    });
  }

  function setCenter(location: google.maps.LatLng) {
    map.panTo(location);
  }

  function createInfoWindow(location: Location) {
    const createInfoItem = () => {
      const hasExtraInfo = location.postal_code || location.opening_hours;

      const items = [
        {
          value: location.address,
          icon: hasExtraInfo ? require('../images/location.png') : require('../images/icon-location-active.png')
        },
        {
          value: location.show_phone_on_map ? location.phoneNumber : null,
          icon: hasExtraInfo ? require('../images/phone.png') : require('../images/icon-phone-active.png')
        },
        {
          value: location.postal_code,
          icon: require('../images/mailbox.png')
        },
        {
          value: location.opening_hours,
          icon: require('../images/clock.png')
        }
      ].filter(item => item.value);
      return items.map(item => `
        <div class="info-item">
          <img class="icon ${hasExtraInfo ? 'small-icon' : ''}" src="${item.icon}" />
          <span class="text">${item.value}</span>
        </div>
      `).join('');
    };

    const contentString = `
      <div class="map-infowindow">
        <div class="title">${location.title}</div>
        ${createInfoItem()}
      </div>
    `;
    return new google.maps.InfoWindow({
      content: contentString
    });
  }

  function openInfoWindow(id: string | number) {
    const { infoWindow, marker } = markerMap[id] || {};
    if (infoWindow) {
      _.each(markerMap, (markerMapObj, markerMapId) => {
        if (String(markerMapId) === String(id)) {
          infoWindow.open({ anchor: marker, map, shouldFocus: false });
        } else {
          markerMapObj.infoWindow.close();
        }
      });
    }
  }

  async function getLocationGeo(location: Location): Promise<google.maps.LatLng> {
    const { lat, lng } = location;
    if (lat && lng) {
      return new google.maps.LatLng(lat, lng);
    }
    // 没有坐标就直接返回0了
    return new google.maps.LatLng(0, 0);
  }

  onMounted(async () => {
    map = await loadMap();
    const promise: Promise<google.maps.LatLng>[] = [];
    props.list.forEach(item => {
      promise.push(
        getLocationGeo(item)
      );
    });

    const res = await Promise.all(promise);
    res.forEach(async (location, index) => {
      const id = props.list[index].id;
      locationMap[id] = location;
      const marker = await setMarker(location, props.list[index]);
      const infoWindow = createInfoWindow(props.list[index]);
      markerMap[id] = {
        infoWindow,
        marker
      };
      marker.addListener('click', () => openInfoWindow(id));
      if (index === 0) {
        setCenter(location);
        openInfoWindow(id);
      }
    });
  });

  watch(() => props.centerLocation, (location) => {
    if (location && location.id) {
      setCenter(locationMap[location.id]);
      openInfoWindow(location.id);
    }
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "root",
    ref: root,
    class: _normalizeClass(["map", { jp: isJapan }])
  }, null, 2))
}
}

})